import React from "react";
import Dashboard from "../components/dashboard/Component";

const Component = () => {
  return <Dashboard />;
};

export default Component;
